<template>
  <div class="text-left">
    <div class="row">
      <div class="col-sm-auto">
        <h3 class="font-weight-bolder mt-2">Medical Incidents</h3>
      </div>

      <template v-if="crew.active == 1 && (isDesignatedManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest && !isKline">
      <AddMedicalIncident></AddMedicalIncident>
      </template>

    </div>
    <div class="row">
      <div class="col-sm-12 text-small text-center">
        <table class="table table-hover table-bordered table-sm">
          <thead class="bg-lightgray">
          <tr>
            <th class="align-middle" width="1%">#</th>
            <th class="align-middle" width="5%">Medical Type</th>
            <th class="align-middle" width="7%">Date</th>
            <th class="align-middle">Diagnosis</th>
            <th class="align-middle" width="7%">Vessel</th>
            <th class="align-middle">Port</th>
            <th class="align-middle" width="9%">Work Status</th>
            <th class="align-middle" width="7%">From</th>
            <th class="align-middle" width="7%">To</th>
            <th class="align-middle" width="3%">Total Days</th>
            <th class="align-middle">Complaints</th>
            <th class="align-middle">Recommendation</th>
            <th class="align-middle" width="6%">File</th>
            <th class="align-middle" width="10%">Action</th>
          </tr>
          </thead>
          <tbody>

          <tr v-if="isLoading">
            <td colspan="100%">
              <app-loading></app-loading>
            </td>
          </tr>

          <template v-else>
            <tr v-for="(crewMedicalIncident, index) in crewMedicalIncidents"
                :key="crewMedicalIncident.id"
                :title="parseUpdateInfo(crewMedicalIncident)"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ parseObjectName(medicalTypeKeys, crewMedicalIncident.medical_type_id) }}</td>
              <td>{{ crewMedicalIncident.incident_date | moment('DD MMM Y') }}</td>
              <td>{{ crewMedicalIncident.diagnosis }}</td>
              <td :title="crewMedicalIncident.vesselHistory">{{ crewMedicalIncident.vessel }}</td>
              <!--                          <td>{{ parseObjectName(portKeys, crewMedicalIncident.port_id) }}</td>-->
              <td>{{ crewMedicalIncident.port }}</td>
              <td>{{ parseObjectName(medicalStatusKeys, crewMedicalIncident.medical_status_id) }}</td>

              <td v-if="crewMedicalIncident.date_from">{{ crewMedicalIncident.date_from | moment('DD MMM Y') }}</td>
              <td v-else>—</td>

              <td v-if="crewMedicalIncident.date_to">{{ crewMedicalIncident.date_to | moment('DD MMM Y') }}</td>
              <td v-else>—</td>

              <td>{{ crewMedicalIncident.totalDays }}</td>

              <td>{{ crewMedicalIncident.complaint }}</td>

              <td class="text-left" style="font-size: 9px;">
                <ul class="item-list">
                  <li v-for="doctorRecommendation in crewMedicalIncident.doctorRecommendations"
                      :key="doctorRecommendation"
                  >
                    {{ parseObjectName(doctorRecommendationKeys, doctorRecommendation) }}
                  </li>
                </ul>
              </td>

              <td>
                <span v-if="crewMedicalIncident.fileCount">{{ crewMedicalIncident.fileCount }} Medical</span> <br/>
                <span v-if="crewMedicalIncident.hospitalizationFiles">{{ crewMedicalIncident.hospitalizationFiles }} Hospital</span>
                <br/>
                <span v-if="crewMedicalIncident.injuryFiles">{{
                    crewMedicalIncident.injuryFiles
                  }} {{ crewMedicalIncident.medical_type_id === 1 ? 'Injury' : 'Illness' }}</span> <br/>
              </td>
              <td>
                <button class="btn btn-outline-info btn-xs mr-1"
                        data-toggle="modal" data-target="#view-crew-incident"
                        @click="updateCrewMedicalIncidentModal(crewMedicalIncident)"
                >
                  <i class="fas fa-eye"></i>
                  View
                </button>
                <template v-if="(crew.active == 1 || isSystemAdmin) && (isDesignatedManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest && !isKline">
                  <button class="btn btn-outline-danger btn-xs"
                          @click="confirmDeleteCrewMedicalIncident(crewMedicalIncident.id)"
                  >
                    <i class="fas fa-trash"></i>
                    Delete
                  </button>
                </template>
              </td>
            </tr>
          </template>


          </tbody>
        </table>
      </div>
    </div>

    <!-- VIEW CREW INCIDENT -->
    <div class="modal fade" id="view-crew-incident" tabindex="-1" role="dialog"
         aria-labelledby="view-crew-incident-title" aria-hidden="true"
         @click="closeDropdown"
    >
      <div class="modal-dialog modal-dialog-centered  modal-xl" role="document">
        <form class="modal-content" @submit.prevent="confirmUpdateMedicalIncident">

          <div class="modal-header">
            <h5 class="modal-title font-weight-bolder" id="view-crew-incident-title">View Medical Incident</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    id="close-view-medical-incident"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="small">
            <div class="modal-body pt-1" v-if="crewMedicalIncident.id">

              <div class="row">

                <div class="col col-sm-12 text-right m-1" v-if="isDesignatedPrincipal || isPrincipal || isPrincipalStaff || isDesignatedManning">
                  <button class="btn btn-outline-danger btn-sm btn-xs float-right"
                          v-if="editable"
                          :key="'cancel-edit'"
                          @click="cancelEdit"
                  >
                    <i class="fas fa-times"></i>
                    Cancel
                  </button>
                  <template v-if="(crew.active == 1 || isSystemAdmin) && !guest">
                    <button type="submit" class="btn btn-warning btn-sm btn-xs float-right mr-2"
                            id="edit-crew-incident"
                            :key="'edit-crew-medical'"
                            v-if="isDesignatedPrincipal || isPrincipal || isPrincipalStaff || isDesignatedManning"
                            style="opacity: .75">
                      <i class="fas fa-edit"></i>
                      {{ editable ? 'Update' : 'Edit' }}
                    </button>
                  </template>
                </div>

                <div class="col col-sm-3">
                  <div class="form-group row mb-0">
                    <label for="vessel" class="col-sm-4 col-form-label font-weight-bold">Vessel :</label>
                    <div class="col-sm-8 px-0">

                      <!--                                            <VesselSelection id="vessel"-->
                      <!--                                                             :selections="vesselKeys"-->
                      <!--                                                             componentId="vessel"-->
                      <!--                                            ></VesselSelection>-->

                      <VesselDropdown
                          v-if="editable"
                          id="vessel"
                          v-model="crewMedicalIncident.vessel_id"
                          :selections="vesselKeys"
                          identifier="vessel"
                          :editable="editable"
                          :other-function="getOtherVesselKeys"
                      ></VesselDropdown>
                      <input type="text" v-else :value="crewMedicalIncident.vessel"
                             :disabled="true"
                             :title="crewMedicalIncident.vesselHistory"
                             class="form-control form-control-xs">

                      <!--                                            <DropdownSelect id="vessel"-->
                      <!--                                                            style="width: 75%"-->
                      <!--                                                            identifier="vessel"-->
                      <!--                                                            :disabled="!editable"-->
                      <!--                                                            :selections="vesselKeys"-->
                      <!--                                                            :other-function="getOtherVesselKeys"-->
                      <!--                                                            @updateVessel="crewMedicalIncident.vessel_id = $event"-->
                      <!--                                            ></DropdownSelect>-->

                      <!--                                            <select id="vessel"-->
                      <!--                                                    class="custom-select custom-select-sm"-->
                      <!--                                                    :disabled="!editable"-->
                      <!--                                                    v-model="crewMedicalIncident.vessel_id"-->
                      <!--                                            >-->
                      <!--                                                <option :value="null">- Select Vessel -</option>-->
                      <!--                                                <option v-for="vesselKey in vesselKeys" :key="vesselKey.id"-->
                      <!--                                                        :value="vesselKey.id"-->
                      <!--                                                >-->
                      <!--                                                    {{ vesselKey.name }}-->
                      <!--                                                </option>-->
                      <!--                                            </select>-->
                    </div>
                  </div>

                  <div class="form-group row mb-0">
                    <label for="incident-manning" class="col-sm-4 col-form-label font-weight-bold pr-1">
                      Manning:
                    </label>
                    <div class="col-sm-8 px-0">
                      <select id="incident-manning"
                              class="custom-select custom-select-sm"
                              :disabled="!editable"
                              v-model="crewMedicalIncident.manning_id"
                      >
                        <option :value="null">- Select Manning -</option>
                        <option v-for="manningKey in manningKeys" :key="manningKey.id"
                                :value="manningKey.id"
                        >
                          {{ manningKey.alias }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col col-sm-3">
                  <div class="form-group row mb-0">
                    <label for="medical-date" class="col-sm-5 col-form-label font-weight-bold">Date :</label>
                    <div class="col-sm-7 px-0">
                      <input type="date" id="medical-date" v-if="editable"
                             class="form-control form-control-sm"
                             v-model="crewMedicalIncident.incident_date"
                      >
                      <input type="text" readonly v-else
                             class="form-control form-control-sm"
                             :value="crewMedicalIncident.incident_date | moment('DD MMM Y')"
                      >
                    </div>
                  </div>

                  <div class="form-group row mb-0">
                    <label for="medical-type" class="col-sm-5 col-form-label font-weight-bold pr-1">Medical Type
                      :</label>
                    <div class="col-sm-7 px-0">
                      <select id="medical-type" required
                              class="custom-select custom-select-sm"
                              :disabled="!editable"
                              v-model="crewMedicalIncident.medical_type_id"
                              @change="crewMedicalIncident.injuries = []"
                      >
                        <option v-for="medicalTypeKey in medicalTypeKeys" :key="medicalTypeKey.id"
                                :value="medicalTypeKey.id"
                        >
                          {{ medicalTypeKey.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col col-sm-2">
                  <div class="form-group row mb-0">
                    <label for="at-sea" class="col-sm-5 col-form-label font-weight-bold pr-1">At Sea :</label>
                    <div class="col-sm-7 px-0 text-center pt-2">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="checkbox" id="at-sea"
                               v-model="crewMedicalIncident.at_sea"
                               :disabled="!editable"
                        >
                        <!--                                                <label class="form-check-label font-weight-bold" for="at-sea">-->
                        <!--                                                    {{ crewMedicalIncident.at_sea ? 'YES' : 'NO' }}-->
                        <!--                                                </label>-->
                      </div>

                    </div>
                  </div>

                  <div class="form-group row mb-0">
                    <label for="pni" class="col-sm-5 col-form-label font-weight-bold pr-1">PNI :</label>
                    <div class="col-sm-7 px-0 text-center pt-2">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="checkbox" id="pni"
                               v-model="crewMedicalIncident.p_and_i"
                               :disabled="!editable"
                        >
                        <!--                                                <label class="form-check-label font-weight-bold" for="pni">-->
                        <!--                                                    {{ crewMedicalIncident.p_and_i ? 'YES' : 'NO' }}-->
                        <!--                                                </label>-->
                      </div>

                    </div>
                  </div>
                </div>

                <div class="col col-sm-3">
                  <div class="form-group row mb-0">
                    <label for="port" class="col-sm-4 col-form-label font-weight-bold pr-1">
                      Port {{ crewMedicalIncident.at_sea ? 'From ' : '' }}:
                    </label>
                    <div class="col-sm-8 px-0">
                      <select id="port"
                              class="custom-select custom-select-sm"
                              :disabled="!editable"
                              v-model="crewMedicalIncident.port_id"
                      >
                        <option :value="null">- Select Port -</option>
                        <option v-for="portKey in portKeys" :key="portKey.id"
                                :value="portKey.id"
                        >
                          {{ portKey.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group row mb-0" v-if="crewMedicalIncident.at_sea">
                    <label for="port-to" class="col-sm-4 col-form-label font-weight-bold">Port To:</label>
                    <div class="col-sm-8 px-0">
                      <select id="port-to"
                              class="custom-select custom-select-sm"
                              :disabled="!editable"
                              v-model="crewMedicalIncident.port_to_id"
                      >
                        <option :value="null">- Select Port -</option>
                        <option v-for="portKey in portKeys" :key="portKey.id"
                                :value="portKey.id"
                        >
                          {{ portKey.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col col-sm-3 offset-6" v-if="crewMedicalIncident.p_and_i">
                  <div class="form-group row mb-0">
                    <label for="pni-code" class="col-sm-4 col-form-label font-weight-bold px-0">PNI Case#:</label>
                    <div class="col-sm-7 px-0">
                      <input type="text" id="pni-code"
                             class="form-control form-control-sm"
                             placeholder="Case# Not Specified"
                             :disabled="!editable"
                             v-model="crewMedicalIncident.pni_code"
                      >
                    </div>
                  </div>
                </div>

              </div>

              <div class="row" v-show="crewMedicalIncident.medical_type_id">

                <div class="col-sm-12">
                  <hr/>
                  <p class="h6 font-weight-bold">
                    {{ crewMedicalIncident.medical_type_id === 1 ? 'Injury' : 'Illness' }} Form
                  </p>
                  <hr/>
                </div>

                <div class="col-md-6">

                  <div class="form-group row mb-1">
                    <label for="complaint" class="col-sm-3 col-form-label font-weight-bold">Complaint :</label>
                    <div class="col-sm-9 px-0">
                                            <textarea class="form-control form-control-sm" id="complaint" rows="5"
                                                      v-model="crewMedicalIncident.complaint"
                                                      :disabled="!editable"
                                                      style="resize: none"></textarea>
                    </div>
                  </div>

                  <div class="form-group row mb-1">

                    <label for="checkboxes" class="col-sm-3 col-form-label pr-0 font-weight-bold"
                           @click="showCheckboxes"
                    >
                      {{ crewMedicalIncident.medical_type_id === 1 ? 'Injuries' : 'Illnesses' }} :
                    </label>
                    <div class="col-sm-9 px-0">

                      <div class="multiselect custom-select custom-select-sm"
                           :class="{'bg-disabled' : !editable}"
                           id="multiselect" @click="showCheckboxes"
                      >
                        <div class="selectBox">
                          {{ selectedInjuries }}
                        </div>
                        <div id="checkboxes" class="dropdown-menu">
                          <div v-for="injuryKey in medicalIssues" :key="injuryKey.id"
                               class="m-1"
                          >
                            <label :for="'injury-' + injuryKey.id">
                              <input type="checkbox" :id="'injury-' + injuryKey.id" class="mr-1"
                                     :value="injuryKey.id"
                                     v-model="crewMedicalIncident.injuries"
                              />
                              {{ injuryKey.name }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="form-group row mb-1">
                    <label for="injury-details" class="col-sm-3 col-form-label font-weight-bold">
                      Details of {{ crewMedicalIncident.medical_type_id === 1 ? 'Injury' : 'Illness' }} :
                    </label>
                    <div class="col-sm-9 px-0">
                                        <textarea id="injury-details" rows="5"
                                                  class="form-control form-control-sm mb-1"
                                                  :disabled="!editable"
                                                  v-model="crewMedicalIncident.injury_details"
                                                  style="resize: none"></textarea>
                    </div>
                  </div>

                  <div class="form-group row mb-1">
                    <label class="col-sm-3 col-form-label font-weight-bold">
                      {{ crewMedicalIncident.medical_type_id === 1 ? 'Injury' : 'Illness' }} Files :
                    </label>

                    <div class="col col-sm-9">
                      <div class="row">
                        <div class="col col-sm-3"
                             v-for="injuryFile in countFiles(crewMedicalIncident.injuryFiles)"
                             :key="injuryFile"
                        >
                          <a role="button" href="#" class="font-weight-bold card-link"
                             @click="updateInjuryFile(injuryFile)"
                          >
                            {{ `File${injuryFile + 1}.pdf` }}
                          </a>

                          <!--                                                    <a role="button" href="#" class="font-weight-bold card-link"-->
                          <!--                                                       data-toggle="modal"-->
                          <!--                                                       data-target="#view-injury-file"-->
                          <!--                                                       @click="updateInjuryFile(injuryFile)"-->
                          <!--                                                    >-->
                          <!--                                                        {{ `File${injuryFile + 1}.pdf`}}-->
                          <!--                                                    </a>-->

                          <a role="button" class="btn btn-sm btn-xs text-danger p-0 m-0"
                             v-if="editable"
                             @click="confirmDeleteInjuryFile(injuryFile)"
                             title="DELETE THIS ATTACHMENT"
                          >
                            <span class="fas fa-minus"></span>
                          </a>
                        </div>


                        <div class="col col-sm-3" v-if="(isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest">
                          <button class="btn btn-sm text-success p-0 m-0"
                                  type="button"
                                  title="Add Injury File"
                                  data-toggle="modal"
                                  data-target="#add-injury-file"
                          >
                            <span class="fas fa-file-upload"></span>
                          </button>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="form-group row mb-1">
                    <label for="injury-diagnosis" class="col-sm-3 col-form-label font-weight-bold">Diagnosis :</label>
                    <div class="col-sm-9 px-0">
                                            <textarea id="injury-diagnosis" rows="5"
                                                      class="form-control form-control-sm"
                                                      :disabled="!editable"
                                                      v-model="crewMedicalIncident.diagnosis"
                                                      style="resize: none"></textarea>
                    </div>
                  </div>

                  <div class="form-group row mb-1">
                    <label for="injury-treatment" class="col-sm-3 col-form-label pr-0 font-weight-bold"
                    >Treatment Given :</label>
                    <div class="col-sm-9 px-0">
                                            <textarea id="injury-treatment" rows="5"
                                                      class="form-control form-control-sm"
                                                      :disabled="!editable"
                                                      v-model="crewMedicalIncident.treatment"
                                                      style="resize: none"></textarea>
                    </div>
                  </div>

                  <div class="form-group row mb-0">
                    <label for="injury-examination" class="col-sm-3 col-form-label font-weight-bold">Examinations
                      :</label>
                    <div class="col-sm-9 px-0">
                                            <textarea class="form-control form-control-sm"
                                                      id="injury-examination" rows="5"
                                                      :disabled="!editable"
                                                      v-model="crewMedicalIncident.examination"
                                                      style="resize: none"></textarea>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group row mb-1">
                    <label class="col-sm-3 col-form-label font-weight-bold" for="patient-found">Patient Found :</label>
                    <div class="col-sm-9 px-0">
                      <div class="form-group row mb-0">
                        <div class="col-sm-8 my-2 px-0">
                          <select class="custom-select custom-select-sm" id="patient-found"
                                  :disabled="!editable"
                                  v-model="crewMedicalIncident.medical_status_id"
                          >
                            <option :value="null">Select Patient Status</option>
                            <option v-for="medicalStatusKey in medicalStatusKeys"
                                    :key="medicalStatusKey.id"
                                    :value="medicalStatusKey.id"
                            >
                              {{ medicalStatusKey.name }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <template v-if="crewMedicalIncident.medical_status_id === 2">
                        <div class="form-group row mb-0">
                          <label for="lightDutyStartDate" class="col-sm-3 col-form-label px-0 font-weight-bold">Date
                            From :</label>
                          <div class="col-sm-5 px-0">
                            <input type="date" id="lightDutyStartDate" v-if="editable"
                                   class="form-control form-control-sm"
                                   :disabled="!editable"
                                   v-model="crewMedicalIncident.date_from"
                            >
                            <input type="text" readonly v-else
                                   class="form-control form-control-sm"
                                   :value="crewMedicalIncident.date_from | moment('DD MMM Y')"
                            >
                          </div>
                        </div>
                        <div class="form-group row mb-0">
                          <label for="lightDutyEndDate" class="col-sm-3 col-form-label px-0 font-weight-bold">Date To
                            :</label>
                          <div class="col-sm-5 px-0">
                            <input type="date" id="lightDutyEndDate" v-if="editable"
                                   class="form-control form-control-sm"
                                   :disabled="!editable"
                                   v-model="crewMedicalIncident.date_to"
                            >
                            <input type="text" readonly v-else
                                   class="form-control form-control-sm"
                                   :value="crewMedicalIncident.date_to | moment('DD MMM Y')"
                            >
                          </div>
                        </div>
                      </template>

                      <template v-else-if="crewMedicalIncident.medical_status_id === 3">
                        <div class="form-group row mb-0">
                          <label for="unfitWorkStartDate" class="col-sm-3 col-form-label px-0 font-weight-bold">Leave
                            From :</label>
                          <div class="col-sm-5 px-0">
                            <input type="date" id="unfitWorkStartDate" v-if="editable"
                                   class="form-control form-control-sm"
                                   :disabled="!editable"
                                   v-model="crewMedicalIncident.date_from"
                            >
                            <input type="text" readonly v-else
                                   class="form-control form-control-sm"
                                   :value="crewMedicalIncident.date_from | moment('DD MMM Y')"
                            >
                          </div>
                        </div>
                        <div class="form-group row mb-0">
                          <label for="unfitWorkEndDate" class="col-sm-3 col-form-label px-0 font-weight-bold">Leave To
                            :</label>
                          <div class="col-sm-5 px-0">
                            <input type="date" id="unfitWorkEndDate" v-if="editable"
                                   class="form-control form-control-sm"
                                   :disabled="!editable"
                                   v-model="crewMedicalIncident.date_to"
                            >
                            <input type="text" readonly v-else
                                   class="form-control form-control-sm"
                                   :value="crewMedicalIncident.date_to | moment('DD MMM Y')"
                            >
                          </div>
                        </div>
                      </template>

                      <template
                          v-else-if="crewMedicalIncident.medical_status_id === 4 || crewMedicalIncident.medical_status_id === 5">
                        <div class="form-group row mb-0">
                          <label for="unfitDisembarkationDate" class="col-sm-4 col-form-label px-0 font-weight-bold">
                            {{ crewMedicalIncident.medical_status_id === 4 ? 'Disembarkation Date' : 'Date of Death' }}
                            :
                          </label>
                          <div class="col-sm-4 px-0">
                            <input type="date" id="unfitDisembarkationDate" v-if="editable"
                                   class="form-control form-control-sm"
                                   :disabled="!editable"
                                   v-model="crewMedicalIncident.date_from"
                            >
                            <input type="text" readonly v-else
                                   class="form-control form-control-sm"
                                   :value="crewMedicalIncident.date_from | moment('DD MMM Y')"
                            >
                          </div>
                        </div>
                      </template>

                    </div>
                  </div>
                  <div class="form-group row my-1">
                    <label class="col-sm-auto col-form-label font-weight-bold">Doctor's Recommendation :</label>
                  </div>

                  <div class="form-group row mb-1"
                       v-for="doctorRecommendationKey in doctorRecommendationKeys"
                       :key="doctorRecommendationKey.id"
                  >
                    <template
                        v-if="crewMedicalIncident.doctorRecommendations.some(recommendationId => recommendationId === doctorRecommendationKey.id) || editable">
                      <div class="col-sm-9 offset-3 pl-0 pr-3">
                        <div class="form-check mt-2">

                          <input class="form-check-input" type="checkbox"
                                 :id="'recommendation-' + doctorRecommendationKey.id"
                                 :value="doctorRecommendationKey.id"
                                 v-model="crewMedicalIncident.doctorRecommendations"
                                 :disabled="!editable"
                          >
                          <label class="form-check-label"
                                 :for="'recommendation-' + doctorRecommendationKey.id"
                          >
                            {{ doctorRecommendationKey.name }}
                          </label>

                        </div>
                      </div>

                      <template v-if="doctorRecommendationKey.id == 3 && hospitalization">

                        <label for="new-hospitalization-start-date"
                               class="col-sm-3 offset-3 col-form-label pl-0 font-weight-bold"
                        >Start Date :</label>
                        <input type="date" id="new-hospitalization-start-date"
                               class="form-control form-control-sm col-sm-5 px-0"
                               :disabled="!editable"
                               @input="calculateHospitalizationDays"
                               v-model="crewMedicalIncident.crewHospitalization.date_from"
                        >

                        <label for="new-hospitalization-end-date"
                               class="col-sm-3 offset-3 col-form-label pl-0 font-weight-bold"
                        >End Date :</label>
                        <input type="date" id="new-hospitalization-end-date"
                               class="form-control form-control-sm col-sm-5 px-0"
                               :disabled="!editable"
                               @input="calculateHospitalizationDays"
                               v-model="crewMedicalIncident.crewHospitalization.date_to"
                        >

                        <label class="col-sm-3 offset-3 col-form-label pl-0 font-weight-bold">Number of Days :</label>
                        <input type="text" disabled
                               class="form-control form-control-sm bg-white col-sm-5 px-0 mb-1"
                               v-model="crewMedicalIncident.crewHospitalization.days"
                        >

                        <label class="col-sm-4 col-form-label pr-0 font-weight-bold mt-1">Hospitalization Files
                          :</label>
                        <div class="col col-sm-2 pl-0 mt-1"
                             v-for="hospitalizationFile in countFiles(crewMedicalIncident.hospitalizationFiles)"
                             :key="hospitalizationFile"
                        >
                          <!--                                                    <a role="button" href="#" class="font-weight-bold card-link"-->
                          <!--                                                       data-toggle="modal"-->
                          <!--                                                       data-target="#view-hospital-file"-->
                          <!--                                                       @click="updateHospitalFile(hospitalizationFile)"-->
                          <!--                                                    >-->
                          <!--                                                        {{ `File${hospitalizationFile + 1}.pdf`}}-->
                          <!--                                                    </a>-->

                          <a role="button" href="#" class="font-weight-bold card-link"
                             @click="updateHospitalFile(hospitalizationFile)"
                          >
                            {{ `File${hospitalizationFile + 1}.pdf` }}
                          </a>

                          <a role="button" class="btn btn-sm btn-xs text-danger p-0 m-0"
                             v-if="editable"
                             title="DELETE THIS ATTACHMENT"
                             @click="confirmDeleteHospitalFile(hospitalizationFile)"
                          >
                            <span class="fas fa-minus"></span>
                          </a>
                        </div>
                        <div class="col col-sm-2 mt-1" v-if="isDesignatedPrincipal">
                          <button class="btn btn-sm text-success p-0 m-0"
                                  type="button"
                                  title="Add Hospital File"
                                  data-toggle="modal"
                                  data-target="#add-hospital-file"
                          >
                            <span class="fas fa-file-upload"></span>
                          </button>
                        </div>
                      </template>

                      <template v-else-if="doctorRecommendationKey.id == 4 && repatriation">

                        <label for="repatriationDate"
                               class="col-sm-3 offset-3 col-form-label pl-0 font-weight-bold mt-1">Repatriation Date
                          :</label>
                        <input type="date" id="repatriationDate"
                               class="form-control form-control-sm col-sm-5 px-0 mb-1"
                               v-model="crewMedicalIncident.crewRepatriation.repatriation_date"
                               @input="calculateRepatriationDays"
                               :disabled="!repatriation"
                        >

                        <div class="col-sm-8 offset-3 form-check mt-2">
                          <input class="form-check-input" type="checkbox" id="afterHospitalization"
                                 :disabled="!editable"
                                 value="After Hospitalization">
                          <label class="form-check-label" for="afterHospitalization">After Hospitalization</label>
                        </div>

                        <label for="arrivalManila" class="col-sm-3 offset-3 col-form-label pr-0 font-weight-bold mt-1">Arrival
                          in Manila :</label>
                        <input type="date" id="arrivalManila"
                               class="form-control form-control-sm col-sm-5 px-0 mt-1"
                               :disabled="!repatriation"
                               @input="calculateRepatriationDays"
                               v-model="crewMedicalIncident.crewRepatriation.arrival_date"
                        >

                        <label for="repatriationDays" class="col-sm-5 col-form-label pr-0 font-weight-bold mt-1">Repatriation
                          Days :</label>
                        <input type="text" id="repatriationDays"
                               class="form-control form-control-sm bg-white col-sm-7 px-0 mt-1"
                               v-model="crewMedicalIncident.crewRepatriation.days"
                               disabled>

                      </template>
                    </template>
                  </div>

                  <div class="form-group row">
                    <label for="doctorsRemaks" class="col-sm-3 col-form-label pr-0 font-weight-bold">Doctor's Remarks
                      :</label>
                    <div class="col-sm-9">
                                            <textarea class="form-control form-control-sm" id="doctorsRemaks" rows="5"
                                                      v-model="crewMedicalIncident.doctor_remarks"
                                                      :disabled="!editable"
                                                      style="resize: none"></textarea>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label pr-0 font-weight-bold mt-1">Medical Incident Files :</label>
                    <div class="col col-sm-2 pl-0 mt-1"
                         v-for="medicalFile in countFiles(crewMedicalIncident.fileCount)"
                         :key="medicalFile"
                    >
                      <!--                                            <a role="button" href="#" class="font-weight-bold card-link"-->
                      <!--                                               data-toggle="modal"-->
                      <!--                                               data-target="#view-medical-incident-file"-->
                      <!--                                               @click="updateMedicalIncidentFile(medicalFile)"-->
                      <!--                                            >-->
                      <!--                                                {{ `File${ medicalFile + 1 }.pdf`}}-->
                      <!--                                            </a>-->

                      <a role="button" href="#" class="font-weight-bold card-link"
                         @click="updateMedicalIncidentFile(medicalFile)"
                      >
                        {{ `File${medicalFile + 1}.pdf` }}
                      </a>
                      <a role="button" class="btn btn-sm btn-xs text-danger p-0 m-0"
                         v-if="editable"
                         title="DELETE THIS ATTACHMENT"
                         @click="confirmDeleteMedicalIncidentFile(medicalFile)"
                      >
                        <span class="fas fa-minus"></span>
                      </a>
                    </div>
                    <div class="col col-sm-2 mt-1">
                      <button class="btn btn-sm text-success p-0 m-0"
                              type="button"
                              title="Add Medical Incident File"
                              data-toggle="modal"
                              data-target="#add-medical-incident-file"
                              v-if="(isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest"
                      >
                        <span class="fas fa-file-upload"></span>
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-sm mx-1 float-right" data-dismiss="modal">
                <i class="fas fa-times"></i>
                Close
              </button>
            </div>
          </div>

        </form>
      </div>
    </div>
    <!-- VIEW CREW INCIDENT -->

    <div class="modal fade" id="view-injury-file" tabindex="-1" role="dialog"
         aria-hidden="true" aria-labelledby="view-injury-file-title"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bolder" id="view-injury-file-title">
              Injury File
            </h5>
            <button type="button" class="close"
                    data-dismiss="modal" aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center text-small">
            <iframe class="test" :src="injuryFile"
                    frameborder="0" height="650" width="720"
            ></iframe>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="add-injury-file" tabindex="-1" role="dialog"
         aria-hidden="true" aria-labelledby="add-injury-file-title"
    >

      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bolder" id="add-injury-file-title">
              Add Injury File
            </h5>
            <button type="button" class="close" id="close-add-injury-file"
                    data-dismiss="modal" aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center text-small">
            <form class="form-group form-row mb-1 mt-1" @submit.prevent="confirmAddInjuryAttachment">
              <label class="col col-sm-2 col-form-label font-weight-bolder text-left"
                     for="add-injury-input-file"
              >
                Injury File:
              </label>
              <div class="col col-sm-7" id="add-injury-file-container">
                <input type="file" id="add-injury-input-file"
                       required
                       accept="application/pdf"
                       class="form-control form-control-sm form-control-xs"
                >
              </div>
              <div class="col col-sm-3">
                <button type="submit" class="btn btn-sm btn-primary">
                  <span class="fas fa-save"></span>
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="view-hospital-file" tabindex="-1" role="dialog"
         aria-hidden="true" aria-labelledby="view-injury-file-title"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bolder" id="view-hospital-file-title">
              Hospital File
            </h5>
            <button type="button" class="close"
                    data-dismiss="modal" aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center text-small">
            <iframe class="test" :src="hospitalFile"
                    frameborder="0" height="650" width="720"
            ></iframe>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="add-hospital-file" tabindex="-1" role="dialog"
         aria-hidden="true" aria-labelledby="add-hospital-file-title"
    >

      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bolder" id="add-hospital-file-title">
              Add Hospital File
            </h5>
            <button type="button" class="close" id="close-add-hospital-file"
                    data-dismiss="modal" aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center text-small">
            <form class="form-group form-row mb-1 mt-1" @submit.prevent="confirmAddHospitalAttachment">
              <label class="col col-sm-3 col-form-label font-weight-bolder text-left"
                     for="add-injury-input-file"
              >
                Hospital File:
              </label>
              <div class="col col-sm-7" id="add-hospital-file-container">
                <input type="file" id="add-hospital-input-file"
                       required
                       accept="application/pdf"
                       class="form-control form-control-sm form-control-xs"
                >
              </div>
              <div class="col col-sm-2">
                <button type="submit" class="btn btn-sm btn-primary">
                  <span class="fas fa-save"></span>
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="view-medical-incident-file" tabindex="-1" role="dialog"
         aria-hidden="true" aria-labelledby="view-medical-incident-file-title"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bolder" id="view-medical-incident-file-title">
              Medical Incident File
            </h5>
            <button type="button" class="close"
                    data-dismiss="modal" aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center text-small">
            <iframe class="test" :src="medicalIncidentFile"
                    frameborder="0" height="650" width="720"
            ></iframe>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="add-medical-incident-file" tabindex="-1" role="dialog"
         aria-hidden="true" aria-labelledby="add-medical-incident-file-title"
    >

      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bolder" id="add-medical-incident-file-title">
              Add Medical Incident File
            </h5>
            <button type="button" class="close" id="close-add-medical-incident-file"
                    data-dismiss="modal" aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center text-small">
            <form class="form-group form-row mb-1 mt-1" @submit.prevent="confirmAddMedicalIncidentFile">
              <label class="col col-sm-4 col-form-label font-weight-bolder text-left"
                     for="add-medical-incident-input-file"
              >
                Medical Incident File:
              </label>
              <div class="col col-sm-6" id="add-medical-incident-file-container">
                <input type="file" id="add-medical-incident-input-file"
                       required
                       accept="application/pdf"
                       class="form-control form-control-sm form-control-xs"
                >
              </div>
              <div class="col col-sm-2">
                <button type="submit" class="btn btn-sm btn-primary">
                  <span class="fas fa-save"></span>
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import AddMedicalIncident
  from '@/components/sub_components/master_lists/crews/crew_show_components/medical_issues/add/AddMedicalIncident';
import AppLoading from "@/components/elements/AppLoading";
// import DropdownSelect from "@/components/elements/DropdownSelect";
// import VesselSelection from "@/components/elements/VesselSelection";
import VesselDropdown from "@/components/elements/VesselDropdown";
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {formMixin} from "@/mixins/formMixin";
import {dataMixin} from "@/mixins/dataMixin";
import {gateMixin} from "@/mixins/gateMixin";
import {mapActions, mapGetters} from 'vuex';

export default {
  name: "MedicalIncidents",
  mixins: [vueAppMixin, formMixin, dataMixin, gateMixin],
  components: {
    AddMedicalIncident,
    // DropdownSelect,
    // VesselSelection,
    VesselDropdown,
    AppLoading
  },
  data() {
    return {
      crewMedicalIncident: {},
      origCrewMedicalIncident: {},
      crewMedicalIncidentErrors: {},
      editable: false,
      injuryFile: '',
      hospitalFile: '',
      medicalIncidentFile: ''
    }
  },

  methods: {
    ...mapActions([
      'getCrewMedicalIncidents',
      'getVesselKeys',
      'getPortKeys',
      'getMedicalTypeKeys',
      'getInjuryKeys',
      'getMedicalStatusKeys',
      'getDoctorRecommendationKeys',
      'getManningKeys',
      'updateCrewMedicalIncident',
      'getInjuryFile',
      'addInjuryFile',
      'deleteInjuryFile',
      'deleteCrewMedicalIncident',
      'getHospitalFile',
      'deleteHospitalFile',
      'addHospitalFile',
      'getMedicalIncidentFile',
      'deleteMedicalIncidentFile',
      'addMedicalIncidentFile',
      'getOtherVesselKeys'
    ]),

    async initializeData() {
      let params = {
        crewId: this.crew.id
      }
      await this.getCrewMedicalIncidents(params);
      if (this.isOchg && !this.isSystemAdmin) {
        let vesselParams = {
          manningId: this.crew.manning_id
        };
        await this.getVesselKeys(vesselParams);
      } else {
        await this.getVesselKeys();
      }
      await this.getPortKeys();
      await this.getMedicalTypeKeys();
      await this.getInjuryKeys();
      await this.getMedicalStatusKeys();
      await this.getDoctorRecommendationKeys();
      await this.getManningKeys();
    },

    updateCrewMedicalIncidentModal(crewMedicalIncident) {
      this.editable = false;
      this.crewMedicalIncident = Object.assign({}, crewMedicalIncident)
      this.origCrewMedicalIncident = Object.assign({}, crewMedicalIncident)
    },

    async confirmUpdateMedicalIncident() {
      if (this.editable) {
        if (!this.crewMedicalIncident.at_sea) this.crewMedicalIncident.port_to_id = null;
        if (!this.hospitalization) this.crewMedicalIncident.crewHospitalization = false;
        if (!this.repatriation) this.crewMedicalIncident.crewRepatriation = false;
        // if(this.crewMedicalIncident.medical_type_id != 1) {
        //     this.crewMedicalIncident.injuries = [];
        //     this.crewMedicalIncident.injury_details = '';
        // }
        if (await this.confirmUpdate()) {
          if (this.crewMedicalIncident.p_and_i === true) {
            this.crewMedicalIncident.p_and_i = 1;
          }
          let updatedCrewIncident = await this.updateCrewMedicalIncident(this.crewMedicalIncident);
          if (updatedCrewIncident) {
            if (updatedCrewIncident.errors) {
              this.crewMedicalIncidentErrors = updatedCrewIncident.errors;
            } else {
              this.successAlert('Crew Medical Incident Successfully Updated', 'UPDATE');
              document.getElementById('close-view-medical-incident').click();
              this.editable = false;
            }
          } else {
            this.errorAlert('Crew Medical Incident Failed to Update', 'UPDATE');
          }
        }
      } else {
        this.editable = true;
      }
    },

    cancelEdit() {
      this.crewMedicalIncident = Object.assign({}, this.origCrewMedicalIncident);
      this.editable = false;
    },

    showCheckboxes() {
      if (this.editable) {
        let checkboxes = document.getElementById("checkboxes");
        if (!this.expanded) {
          checkboxes.style.display = "block";
          this.expanded = true;
        } else {
          checkboxes.style.display = "none";
          this.expanded = false;
        }
      }
    },

    closeDropdown(source) {
      if (this.expanded) {
        let node = source.target;
        let included = false;
        while (node.parentElement) {
          if (node.id === 'multiselect') {
            included = true;
            break;
          }
          node = node.parentElement;
        }
        if (!included) this.showCheckboxes();
      }
    },

    calculateHospitalizationDays() {
      if (this.crewMedicalIncident.crewHospitalization.date_from && this.crewMedicalIncident.crewHospitalization.date_to) {
        let dateFrom = new Date(this.crewMedicalIncident.crewHospitalization.date_from);
        let dateTo = new Date(this.crewMedicalIncident.crewHospitalization.date_to);
        let daysDifference = (dateTo.getTime() - dateFrom.getTime()) / (1000 * 3600 * 24)
        this.crewMedicalIncident.crewHospitalization.days = daysDifference
      }
    },

    initializeRepatriationDate(recommendationId) {
      if (recommendationId == 3 || recommendationId == 4) {
        let hospitalization = document.getElementById('recommendation-' + 3).checked;
        let repatriation = document.getElementById('recommendation-' + 4).checked;
        if (repatriation && hospitalization && !this.crewMedicalIncident.crewRepatriation.repatriation_date) {
          this.crewMedicalIncident.crewRepatriation.repatriation_date = this.crewMedicalIncident.crewHospitalization.date_to;
        }
      }
    },

    calculateRepatriationDays() {
      if (this.crewMedicalIncident.crewRepatriation.repatriation_date && this.crewMedicalIncident.crewRepatriation.arrival_date) {
        let dateFrom = new Date(this.crewMedicalIncident.crewRepatriation.repatriation_date);
        let dateTo = new Date(this.crewMedicalIncident.crewRepatriation.arrival_date);
        let daysDifference = (dateTo.getTime() - dateFrom.getTime()) / (1000 * 3600 * 24)
        this.crewMedicalIncident.crewRepatriation.days = daysDifference
      }
    },

    countFiles(fileCount) {
      let attachments = [];
      attachments = [...Array(fileCount).keys()];
      return attachments;
    },

    async updateInjuryFile(index) {
      this.injuryFile = '';
      let params = {
        crewMedicalIncidentId: this.crewMedicalIncident.id,
        index: index
      };
      let injuryFile = await this.getInjuryFile(params);
      if (injuryFile) this.injuryFile = injuryFile;
      this.injuryFile = injuryFile ? `data:application/pdf;base64,${injuryFile}` : '';
      await this.pdfViewer(`Injury File ${index + 1}`, this.injuryFile);
    },

    async updateHospitalFile(index) {
      this.hospitalFile = '';
      let params = {
        crewMedicalIncidentId: this.crewMedicalIncident.id,
        index: index
      };
      let hospitalFile = await this.getHospitalFile(params);
      if (hospitalFile) this.hospitalFile = hospitalFile;
      this.hospitalFile = hospitalFile ? `data:application/pdf;base64,${hospitalFile}` : '';
      await this.pdfViewer(`Hospital File ${index + 1}`, this.hospitalFile);
    },

    async confirmAddInjuryAttachment() {
      if (await this.confirmCreateAlert('Are you sure you want to add this injury file?')) {
        let formData = new FormData();
        formData.append('crewMedicalIncidentId', this.crewMedicalIncident.id);
        let input = document.getElementById('add-injury-input-file');
        if (input.files && input.files.length) {
          formData.append(`injuryFile`, input.files[0]);
        }
        let addedInjuryFileAttachment = await this.addInjuryFile(formData);
        if (addedInjuryFileAttachment) {
          this.crewMedicalIncident.injuryFiles++;
          this.origCrewMedicalIncident.injuryFiles++;
          this.successAlert('Injury File Successfully Added', 'UPLOAD');
          document.getElementById('close-add-injury-file').click();
        } else {
          this.errorAlert('Injury File Failed to Add', 'ADD')
        }
      }
    },

    async confirmDeleteInjuryFile(index) {
      if (await this.confirmDeleteAlert('Are you sure you want to delete this injury file?')) {
        let params = {
          crewMedicalIncidentId: this.crewMedicalIncident.id,
          index: index
        };
        let deletedInjuryFile = await this.deleteInjuryFile(params);
        if (deletedInjuryFile) {
          this.crewMedicalIncident.injuryFiles--;
          this.origCrewMedicalIncident.injuryFiles--;
          this.successAlert('Injury File Successfully Deleted', 'DELETE');
        } else {
          this.errorAlert('Injury File Failed to Delete', 'DELETE')
        }
      }
    },

    async confirmDeleteCrewMedicalIncident(crewMedicalIncidentId) {
      if (await this.confirmDeleteAlert('Are you sure you want to delete this Medical Incident Record?')) {
        let params = {
          crewMedicalIncidentId: crewMedicalIncidentId
        };
        let deletedCrewMedicalIncident = this.deleteCrewMedicalIncident(params);
        if (deletedCrewMedicalIncident) {
          this.successAlert('Crew Medical Successfully Deleted', 'DELETE');
        } else {
          this.errorAlert('Crew Medical Failed to Delete', 'DELETE')
        }
      }
    },

    async confirmDeleteHospitalFile(index) {
      if (await this.confirmDeleteAlert('Are you sure you want to delete this hospital file?')) {
        let params = {
          crewMedicalIncidentId: this.crewMedicalIncident.id,
          index: index
        };
        let deletedHospitalFile = await this.deleteHospitalFile(params);
        if (deletedHospitalFile) {
          this.crewMedicalIncident.hospitalizationFiles--;
          this.origCrewMedicalIncident.hospitalizationFiles--;
          this.successAlert('Hospital File Successfully Deleted', 'DELETE');
        } else {
          this.errorAlert('Hospital File Failed to Delete', 'DELETE')
        }
      }
    },

    async confirmAddHospitalAttachment() {
      if (await this.confirmCreateAlert('Are you sure you want to add this Hospital file?')) {
        let formData = new FormData();
        formData.append('crewMedicalIncidentId', this.crewMedicalIncident.id);
        let input = document.getElementById('add-hospital-input-file');
        if (input.files && input.files.length) {
          formData.append(`hospitalFile`, input.files[0]);
        }
        let addedHospitalAttachment = await this.addHospitalFile(formData);
        if (addedHospitalAttachment) {
          this.crewMedicalIncident.hospitalizationFiles++;
          this.origCrewMedicalIncident.hospitalizationFiles++;
          this.successAlert('Hospital File Successfully Added', 'UPLOAD');
          document.getElementById('close-add-hospital-file').click();
        } else {
          this.errorAlert('Hospital File Failed to Add', 'ADD')
        }
      }
    },

    async updateMedicalIncidentFile(index) {
      this.medicalIncidentFile = '';
      let params = {
        crewMedicalIncidentId: this.crewMedicalIncident.id,
        index: index
      };
      let medicalIncidentFile = await this.getMedicalIncidentFile(params);
      if (medicalIncidentFile) this.medicalIncidentFile = medicalIncidentFile;
      this.medicalIncidentFile = medicalIncidentFile ? `data:application/pdf;base64,${medicalIncidentFile}` : '';
      await this.pdfViewer(`Medical Incident File ${index + 1}`, this.medicalIncidentFile);
    },

    async confirmDeleteMedicalIncidentFile(index) {
      if (await this.confirmDeleteAlert('Are you sure you want to delete this Medical Incident file?')) {
        let params = {
          crewMedicalIncidentId: this.crewMedicalIncident.id,
          index: index
        };
        let deletedMedicalIncidentFile = await this.deleteMedicalIncidentFile(params);
        if (deletedMedicalIncidentFile) {
          this.crewMedicalIncident.fileCount--;
          this.origCrewMedicalIncident.fileCount--;
          this.successAlert('Medical Incident File Successfully Deleted', 'DELETE');
        } else {
          this.errorAlert('Medical Incident File Failed to Delete', 'DELETE')
        }
      }
    },

    async confirmAddMedicalIncidentFile() {
      if (await this.confirmCreateAlert('Are you sure you want to add this Medical Incident file?')) {
        let formData = new FormData();
        formData.append('crewMedicalIncidentId', this.crewMedicalIncident.id);
        let input = document.getElementById('add-medical-incident-input-file');
        if (input.files && input.files.length) {
          formData.append(`medicalIncidentFile`, input.files[0]);
        }
        let addedMedicalIncidentFile = await this.addMedicalIncidentFile(formData);
        if (addedMedicalIncidentFile) {
          this.crewMedicalIncident.fileCount++;
          this.origCrewMedicalIncident.fileCount++;
          this.successAlert('Medical Incident File Successfully Added', 'UPLOAD');
          document.getElementById('close-add-medical-incident-file').click();
        } else {
          this.errorAlert('Medical Incident File Failed to Add', 'ADD')
        }
      }
    },

    parseUpdateInfo(objectData) {
      let updateInfo = '';

      if (objectData.createdBy) updateInfo += `Created By: ${objectData.createdBy} at ${objectData.createdAt}`;
      if (objectData.updatedBy) updateInfo += `\nUpdated By: ${objectData.updatedBy} at ${objectData.updatedAt}`;

      return updateInfo;
    }

  },

  computed: {
    ...mapGetters([
      'crew',
      'crewMedicalIncidents',
      'vesselKeys',
      'medicalTypeKeys',
      'portKeys',
      'medicalStatusKeys',
      'doctorRecommendationKeys',
      'manningKeys',
      'injuryKeys'
    ]),

    hospitalization() {
      return this.crewMedicalIncident.doctorRecommendations
          .some(doctorRecommendation => doctorRecommendation == 3);
    },

    repatriation() {
      return this.crewMedicalIncident.doctorRecommendations
          .some(doctorRecommendation => doctorRecommendation == 4);
    },

    selectedInjuries() {
      let injuries = 'Click to Select Injuries ' + (this.crewMedicalIncident.medical_type_id === 1 ? 'Injuries' : 'Illnesses');
      if (this.crewMedicalIncident.injuries.length) {
        injuries = this.injuryKeys
            .filter(injuryKey => this.crewMedicalIncident.injuries.some(injury => injury === injuryKey.id))
            .map(injuryKey => injuryKey.name)
            .join(', ');
      }
      return injuries;
    },

    medicalIssues() {
      return this.injuryKeys.filter(injuryKey => {
        return injuryKey.is_illness == (this.crewMedicalIncident.medical_type_id === 2)
      });
    },

  },

  created() {
    this.initializeData();
  }
}
</script>

<style scoped>
.bg-lightgray {
  background: lightgray;
}

table td {
  vertical-align: middle;
}

.item-list {
  list-style: none;
  padding: 0;
}

.item-list li:before {
  text-align: center;
  content: "♦";
}

.multiselect {
  width: 91%;
  height: auto;
  /*min-height: 24px;*/
  /*max-height: 24px;*/
  cursor: pointer;
}

.selectBox {
  position: relative;
}

.selectBox select {
  width: 100%;
  font-weight: bold;
}

#checkboxes {
  display: none;
  border: 1px #dadada solid;
}

#checkboxes label {
  display: block;
}

#checkboxes label:hover {
  background-color: #1e90ff;
}

</style>
